import React from "react";
import styled, { css } from "styled-components";

export const SbSection = ({
  draggable = false,
  active,
  title,
  style,
  deleteable,
  blockOrder,
  deleteSection = () => { void (0); }, children,
  onClick,
}) => {
  return (
<CSSsection0
  active={active}
  onClick={onClick}
  style={{
    ...style
  }}>
    <div className="xx_set_head">
      <div className="xx_img_menu_left">
        <div data-xsb-settings-module-onoff="w_pack1">
          <div className="xsb_sett_head">

            {draggable && <div className="xsb_sett_drag" />}

            {title}

          </div>
        </div>
      </div>

      {deleteable && <div className="xx_img_menu_right"><div className="xx_img_menu_li">
        <div className="xx_but_menu_icon xx_but_menu_icon--secondary" onClick={() => { deleteSection(blockOrder); }}><div>delete</div></div>
      </div></div>}

    </div>

    <div className="xx_set_menu xx_set_menu--noborder" />

    {!!children && <div className="xsb_set_line">

      {children}

    </div>}
  </CSSsection0>);
};




export const CSSsection0 = styled.div`
    opacity: 1;
    color: #919fa9;
    margin-bottom: 16px;
    border: ${({active}) => !active ? '1px solid rgba(145, 159, 169, 0.29)' : 'white'};

    &:hover {
      color: #FFF;
      /* background: #4f6374; */
      background-color: rgba(145, 159, 169, 0.07);
    }
`



export const SbSectionWhite = ({
  draggable = false,
  active,
  title,
  style,
  deleteable,
  blockOrder,
  deleteSection = () => { void (0); }, children,
  onClick,
}) => {
  return (<div className="xx_set_sect"
  onClick={onClick}
  style={{
    opacity: 1,
    color: active ? 'black' : '#657685',
    boxShadow: active ?  'inset 0 0 0 2px #157afb' : 'none',
    ...style
  }}>
    <div className="xx_set_head">
      <div className="xx_img_menu_left">
        <div data-xsb-settings-module-onoff="w_pack1">
          <div className="xsb_sett_head">

            {draggable && <div className="xsb_sett_drag" />}

            {title}

          </div>
        </div>
      </div>

      {deleteable && <div className="xx_img_menu_right"><div className="xx_img_menu_li">
        <div className="xx_but_menu_icon xx_but_menu_icon--secondary" onClick={() => { deleteSection(blockOrder); }}><div>delete</div></div>
      </div></div>}

    </div>

    <div className="xx_set_menu xx_set_menu--noborder" />

    {!!children && <div className="xsb_set_line xsb_set_line--fullsub">

      {children}

    </div>}
  </div>);
};
